<!-- 预付款申请数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="170px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType!=3">
                                 <el-form-item v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                               :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1,trigger: ['blur', 'change']}] : []">
                                    <template>
                                       <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                   :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                   effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                          <el-input v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
                                                    :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                                             <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                                             </el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isdisabled="formOneValue.isChange == 0"
                                                v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                       <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                  v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                          </el-option>
                                       </el-select>
                                       <div v-else-if="formOneValue.entityField == 'licensePath'">
                                          <div>
                                             <input style="display: none;" type="file" id="licensePath" accept="image/*" multiple name="licensePath"
                                                    @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e,formOneValue.entityField) }" />
                                             <label for="licensePath" class="image_label">上传</label>
                                          </div>
                                          <ul class="uploadList" v-if="sendDataInfo[formOneValue.entityField]" style="margin-top: 5px;">
                                             <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key" class="image">
                                                <i class="el-icon-error del" @click="delRemove( key,formOneValue.entityField)"></i>
                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]"></cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <div v-else-if="formOneValue.entityField == 'drugquaPath'">
                                          <div>
                                             <input style="display: none;" type="file" id="drugquaPath" accept="image/*" multiple name="drugquaPath"
                                                    @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e,formOneValue.entityField) }" />
                                             <label for="drugquaPath" class="image_label">上传</label>
                                          </div>
                                          <ul class="uploadList" v-if="sendDataInfo[formOneValue.entityField]" style="margin-top: 5px;">
                                             <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key" class="image">
                                                <i class="el-icon-error del" @click="delRemove( key,formOneValue.entityField)"></i>
                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]"></cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <div v-else-if="formOneValue.entityField == 'prrmitPath'">
                                          <div>
                                             <input style="display: none;" type="file" id="prrmitPath" accept="image/*" multiple name="prrmitPath"
                                                    @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e,formOneValue.entityField) }" />
                                             <label for="prrmitPath" class="image_label">上传</label>
                                          </div>
                                          <ul class="uploadList" v-if="sendDataInfo[formOneValue.entityField]" style="margin-top: 5px;">
                                             <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key" class="image">
                                                <i class="el-icon-error del" @click="delRemove( key,formOneValue.entityField)"></i>
                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]"></cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <el-input v-else-if="formOneValue.entityField == 'remark' || formOneValue.entityField == 'saiAddress'" type="textarea" :disabled="formOneValue.isChange == 0"
                                                 @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                       <el-input v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                    </template>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 3">
                                 <el-form-item :label="formOneValue.showField+':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey">
                                    <template>
                                       <span v-if="formOneValue.fieldType == 'date'">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                                       <div v-else-if="formOneValue.entityField == 'licensePath'||formOneValue.entityField == 'prrmitPath'">
                                          <div style="width: 250px;display: flex;align-items: center;flex-wrap: wrap;" v-if="sendDataInfo[formOneValue.entityField]">
                                             <cusImage v-for="(item,index) in sendDataInfo[formOneValue.entityField].split(',')" :key="index" style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${item}`"
                                                       :preview-src-list="[`${imgUrl}/${item}`]">
                                             </cusImage>
                                          </div>
                                       </div>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                       </span>
                                       <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                    </template>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                        <div v-if="scope.index == 1">
                           <el-form :inline="true" size="mini">
                              <div v-if="dataActionBox.actionType != 3" id="operateBtn">
                                 <el-button type="primary" size="mini" @click="addCar('sendDataInfo')">
                                    新增</el-button>
                                 <el-button type="primary" size="mini" @click="deleteCar()">删除
                                 </el-button>
                              </div>
                              <el-table size="mini" class="baseTable" v-if="scope.row.jurconfigform" ref="mxTableRef" :data="sendDataInfo.dewmuLogisticsCars" border style="width: 100%" :height="tableHeight">
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 3">
                                    <template slot-scope="scope">
                                       <el-radio v-model="carIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" :show-overflow-tooltip="!isImgField(formOneValue) && !isFileField(formOneValue)"
                                                  :width="(isImgField(formOneValue) || isFileField(formOneValue)) ? 120 : formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                  v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <div v-if="dataActionBox.actionType != 3">
                                          <!-- 图片上传，每行仅一张 -->
                                          <div v-if="isImgField(formOneValue)">
                                             <input style="display: none;" type="file" :id="`carUpload${formOneKey}_${scope.$index}`" accept="image/*"
                                                    @change="(e) => { singleFileUpload(e, formOneValue.entityField, sendDataInfo.dewmuLogisticsCars[scope.$index]) }" />
                                             <ul class="upload">
                                                <li v-if="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]">
                                                   <i class="el-icon-error del" @click="delImg(formOneValue.entityField, sendDataInfo.dewmuLogisticsCars[scope.$index])"></i>
                                                   <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`"
                                                             :preview-src-list="[`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`]"></cusImage>
                                                </li>
                                                <li v-else>
                                                   <label :for="`carUpload${formOneKey}_${scope.$index}`" class="image_label">
                                                      <i class="el-icon-plus icon"></i>
                                                   </label>
                                                </li>
                                             </ul>
                                          </div>
                                          <!-- 文件上传，每行仅一个 -->
                                          <div v-else-if="isFileField(formOneValue)">
                                             <input style="display: none;" type="file" :id="`carFileUpload${formOneKey}_${scope.$index}`" accept=".pdf"
                                                    @change="(e) => { singleFileUpload(e, formOneValue.entityField, sendDataInfo.dewmuLogisticsCars[scope.$index]) }" />
                                             <div v-if="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]" class="file-item">
                                                <i class="el-icon-error del" @click="delImg(formOneValue.entityField, sendDataInfo.dewmuLogisticsCars[scope.$index])"></i>
                                                <a :href="`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`" target="_blank" class="file-link">
                                                   <i class="el-icon-document"></i>
                                                   <span class="file-name">{{ getFileName(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]) }}</span>
                                                </a>
                                             </div>
                                             <label v-else :for="`carFileUpload${formOneKey}_${scope.$index}`" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </div>
                                          <!-- 下拉选择 -->
                                          <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isChange == 1"
                                                     v-model="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="(item, fIndex) in parseFormatterContent(formOneValue.formatterContent)" :key="fIndex" :label="item.label" :value="item.value">
                                             </el-option>
                                          </el-select>
                                          <!-- 备注 -->
                                          <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'input'  && formOneValue.isChange == 1"
                                                    v-model="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]">
                                          </el-input>
                                          <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]"></df-date>
                                          <span v-else-if="formOneValue.isRift == 1">
                                             <a @click="toDetail(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.riftField])">{{sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}}</a>
                                          </span>
                                          <span v-else>{{sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                       <div v-else>
                                          <div v-if="isImgField(formOneValue)">
                                             <ul class="upload" v-if="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]">
                                                <li>
                                                   <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`"
                                                             :preview-src-list="[`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`]"></cusImage>
                                                </li>
                                             </ul>
                                          </div>
                                          <div v-else-if="isFileField(formOneValue)">
                                             <div v-if="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]" class="file-item">
                                                <a :href="`${imgUrl}/${sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}`" target="_blank" class="file-link">
                                                   <i class="el-icon-document"></i>
                                                   <span class="file-name">{{ getFileName(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]) }}</span>
                                                </a>
                                             </div>
                                          </div>
                                          <span v-else-if="formOneValue.fieldType == 'formatter'">
                                             {{ formatFormatterValue(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField], formOneValue.formatterContent) }}
                                          </span>
                                          <span v-else-if="formOneValue.fieldType=='date'">
                                             <span
                                                   v-if="sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]">{{ $common.getLocalTime(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField])}}</span>
                                          </span>
                                          <span v-else-if="formOneValue.isRift == 1">
                                             <a @click="toDetail(sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.riftField])">{{sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}}</a>
                                          </span>
                                          <span v-else>{{sendDataInfo.dewmuLogisticsCars[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                        <div v-if="scope.index == 2">
                           <el-form :inline="true" size="mini">
                              <div v-if="dataActionBox.actionType != 3" id="operateBtn">
                                 <el-button type="primary" size="mini" @click="addDriver('sendDataInfo')">
                                    新增</el-button>
                                 <el-button type="primary" size="mini" @click="deleteDriver()">删除
                                 </el-button>
                              </div>
                              <el-table size="mini" class="baseTable" v-if="scope.row.jurconfigform" ref="mxTableRef" :data="sendDataInfo.dewmuLogisticsDrivers" border style="width: 100%" :height="tableHeight">
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 3">
                                    <template slot-scope="scope">
                                       <el-radio v-model="driverIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" :show-overflow-tooltip="!isImgField(formOneValue) && !isFileField(formOneValue)"
                                                  :width="(isImgField(formOneValue) || isFileField(formOneValue)) ? 120 : formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                  v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <div v-if="dataActionBox.actionType != 3">
                                          <!-- 图片上传，每行仅一张 -->
                                          <div v-if="isImgField(formOneValue)">
                                             <input style="display: none;" type="file" :id="`driverUpload${formOneKey}_${scope.$index}`" accept="image/*"
                                                    @change="(e) => { singleFileUpload(e, formOneValue.entityField, sendDataInfo.dewmuLogisticsDrivers[scope.$index]) }" />
                                             <ul class="upload">
                                                <li v-if="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]">
                                                   <i class="el-icon-error del" @click="delImg(formOneValue.entityField, sendDataInfo.dewmuLogisticsDrivers[scope.$index])"></i>
                                                   <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`"
                                                             :preview-src-list="[`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`]"></cusImage>
                                                </li>
                                                <li v-else>
                                                   <label :for="`driverUpload${formOneKey}_${scope.$index}`" class="image_label">
                                                      <i class="el-icon-plus icon"></i>
                                                   </label>
                                                </li>
                                             </ul>
                                          </div>
                                          <!-- 文件上传，每行仅一个 -->
                                          <div v-else-if="isFileField(formOneValue)">
                                             <input style="display: none;" type="file" :id="`driverFileUpload${formOneKey}_${scope.$index}`" accept=".pdf"
                                                    @change="(e) => { singleFileUpload(e, formOneValue.entityField, sendDataInfo.dewmuLogisticsDrivers[scope.$index]) }" />
                                             <div v-if="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]" class="file-item">
                                                <i class="el-icon-error del" @click="delImg(formOneValue.entityField, sendDataInfo.dewmuLogisticsDrivers[scope.$index])"></i>
                                                <a :href="`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`" target="_blank" class="file-link">
                                                   <i class="el-icon-document"></i>
                                                   <span class="file-name">{{ getFileName(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]) }}</span>
                                                </a>
                                             </div>
                                             <label v-else :for="`driverFileUpload${formOneKey}_${scope.$index}`" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </div>
                                          <!-- 下拉选择 -->
                                          <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isChange == 1"
                                                     v-model="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="(item, fIndex) in parseFormatterContent(formOneValue.formatterContent)" :key="fIndex" :label="item.label" :value="item.value">
                                             </el-option>
                                          </el-select>
                                          <!-- 备注 -->
                                          <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'input'  && formOneValue.isChange == 1"
                                                    v-model="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]">
                                          </el-input>
                                          <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]"></df-date>
                                          <span v-else-if="formOneValue.isRift == 1">
                                             <a
                                                @click="toDetail(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.riftField])">{{sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}}</a>
                                          </span>
                                          <span v-else>{{sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                       <div v-else>
                                          <div v-if="isImgField(formOneValue)">
                                             <ul class="upload" v-if="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]">
                                                <li>
                                                   <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`"
                                                             :preview-src-list="[`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`]"></cusImage>
                                                </li>
                                             </ul>
                                          </div>
                                          <div v-else-if="isFileField(formOneValue)">
                                             <div v-if="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]" class="file-item">
                                                <a :href="`${imgUrl}/${sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}`" target="_blank" class="file-link">
                                                   <i class="el-icon-document"></i>
                                                   <span class="file-name">{{ getFileName(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]) }}</span>
                                                </a>
                                             </div>
                                          </div>
                                          <span v-else-if="formOneValue.fieldType == 'formatter'">
                                             {{ formatFormatterValue(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField], formOneValue.formatterContent) }}
                                          </span>
                                          <span v-else-if="formOneValue.fieldType=='date'">
                                             <span
                                                   v-if="sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]">{{ $common.getLocalTime(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField])}}</span>
                                          </span>
                                          <span v-else-if="formOneValue.isRift == 1">
                                             <a
                                                @click="toDetail(sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.riftField])">{{sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}}</a>
                                          </span>
                                          <span v-else>{{sendDataInfo.dewmuLogisticsDrivers[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                  <el-button type="primary" @click="exportData" v-if="dataActionBox.actionType==3">导出</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
               </div>
            </div>
         </div>

      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "logisticsListAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         token: {
            token: sessionStorage.getItem("token"),
         },
         tableHeight: 0,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            "companyName": "",
            "contractDate": 0,
            "isDefault": 0,
            "licenseDate": 0,
            "licenseNum": "",
            "licensePath": "", //营业执照图片地址
            "loLinker": "",
            "loPhone": "",
            "prrmitDate": 0,
            "prrmitNum": "",
            "prrmitPath": "",//道路经营运输许可证号照片地址
            "remark": "",
            "filingCard": "", //备案车牌号
            driverName: "", //司机名称
            documentsNum: "", //身份证号
            isKdn: "",
            monthCode: "",
            kdnCode: "",
            customerPwd: "",
            customerName: "",
            sendStaff: "",
            sendSite: "",
            payType: '',//运费结算方式
            expType: ''//业务类型
         },
         showTabs: "",
         formDataList: [],
         userOneList: [],
         seId: "",
         seWidth: "",
         height: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {
            smId: "",
         },
         tables: false,
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         requesUrl: "",
         imgUrl: "",
         fileList: [],
         fileList1: [],
         //------------
         driverObj: {},
         carObj: {},
         carIndex: 0,
         driverIndex: 0
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
   },
   //方法集合
   methods: {
      exportData() {
         let params = {
            ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId,
            loId: this.sendDataInfo.loId,
         }
         console.log(this.$store.getters.getConfig.requestUrl + '/logistics/export' + this.$common.getUrl(params),'导出url1111111111111111')
         window.location.href = this.$store.getters.getConfig.requestUrl + '/logistics/export' + this.$common.getUrl(params);
      },
      tabHeight(val) {
         this.tableHeight = val
      },
      //--------------------------------------------------------------------------------
      //新增司机
      addDriver(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               var flag = false
               this.sendDataInfo.dewmuLogisticsDrivers.forEach(item => {
                  if ((item.driverName == "" || item.documentsNum == "" || item.drivingLicenseDate == "") && !flag) {
                     flag = true
                  }
               })
               if (flag) {
                  return this.$message.error("请先完善上面未完善的信息,再新增空白行")
               }
               this.sendDataInfo.dewmuLogisticsDrivers.push({})
               this.driverIndex = this.sendDataInfo.dewmuLogisticsDrivers.length - 1
               for (const key in this.driverObj) {
                  this.$set(this.sendDataInfo.dewmuLogisticsDrivers[this.driverIndex], key, this.driverObj[key])
               }
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      //删除司机
      deleteDriver() {
         this.sendDataInfo.dewmuLogisticsDrivers.splice(this.driverIndex, 1)
         this.driverIndex = 0
      },
      //新增车辆
      addCar(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               var flag = false
               this.sendDataInfo.dewmuLogisticsCars.forEach(item => {
                  if ((item.filingCard == "" || item.travelLicense == "" || item.travelLicenseDate == "") && !flag) {
                     flag = true
                  }
               })
               if (flag) {
                  return this.$message.error("请先完善上面未完善的信息,再新增空白行")
               }
               this.sendDataInfo.dewmuLogisticsCars.push({})
               this.carIndex = this.sendDataInfo.dewmuLogisticsCars.length - 1
               for (const key in this.carObj) {
                  this.$set(this.sendDataInfo.dewmuLogisticsCars[this.carIndex], key, this.carObj[key])
               }
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      //删除车辆
      deleteCar() {
         this.sendDataInfo.dewmuLogisticsCars.splice(this.carIndex, 1)
         this.carIndex = 0
      },
      // 图片列判断：fieldType 配为 imgUrl
      isImgField(item) {
         return item.fieldType == 'imgUrl'
      },
      // 文件列判断：fieldType 配为 fileUrl
      isFileField(item) {
         return item.fieldType == 'fileUrl'
      },
      // 获取文件扩展名
      getFileExt(url) {
         if (!url) return ''
         return url.split('.').pop().toLowerCase()
      },
      // 判断是否为图片文件
      isImageFile(url) {
         var ext = this.getFileExt(url)
         return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)
      },
      // 获取文件显示名称
      getFileName(url) {
         if (!url) return ''
         return url.split('/').pop()
      },
      // 安全解析 formatterContent（兼容单引号等非标准JSON格式）
      parseFormatterContent(content) {
         if (!content) return []
         if (Array.isArray(content)) return content
         try {
            return JSON.parse(content)
         } catch (e) {
            try {
               return new Function('return ' + content)()
            } catch (e2) {
               return []
            }
         }
      },
      // 将 formatter 字段的 value 转为对应的 label 显示
      formatFormatterValue(val, formatterContent) {
         if (val === null || val === undefined || val === '') return ''
         var arr = this.parseFormatterContent(formatterContent)
         for (var i = 0; i < arr.length; i++) {
            if (arr[i].value == val) return arr[i].label
         }
         return val
      },
      // 单图上传：每行仅允许一张，上传成功后覆盖原图
      async singleFileUpload(e, entityField, row) {
         var files = e.target.files
         if (!files.length) return
         const response = await this.$http.uploadFile({ file: files[0] }, true)
         if (response.status == 200) {
            this.$set(row, entityField, response.result[0].fileUrl)
         } else {
            this.$message.error(response.message)
         }
         e.target.value = ""
      },
      // 删除明细行图片
      delImg(entityField, row) {
         this.$set(row, entityField, "")
      },
      delRemove(index, entityField) {
         var arr = []
         if (this.sendDataInfo[entityField]) {
            arr = this.sendDataInfo[entityField].split(",")
         }
         arr.splice(index, 1)
         this.sendDataInfo[entityField] = arr.join()
      },
      async fileUpload(files, length, index, e, entityField) {
         if (length - 1 >= index) {
            const params = {
               file: files[index]
            }
            const response = await this.$http.uploadFile(params, true)
            if (response.status == 200) {
               var arr = []
               if (this.sendDataInfo[entityField]) {
                  arr = this.sendDataInfo[entityField].split(',')
               }
               arr.push(response.result[0].fileUrl)
               this.sendDataInfo[entityField] = arr.join()
               this.fileUpload(files, length, index + 1, e, entityField)
            } else {
               e.target.value = ""
               this.$message.error(response.message)
            }
         } else {
            e.target.value = ""
         }
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) return
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
               .printJurId)
         } else {
            return
         }
      },
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 3) this.$parent.$parent.toDetail(orderId)
         else this.$parent.$parent.$parent.toDetail(orderId)
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type]
         if (type == 'companyName') {
            this.parentSearchData.diValue = this.sendDataInfo.companyName || ""

         }

      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.seIndex)
         })
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },

      initActionBox(sendDataInfo) {
         this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.dataActionBox.actionType = 0;
               this.$emit('drawerCancel')
               this.tables = false;
               this.init();
               this.$refs[sendDataInfo].resetFields();
            })
            .catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.isDefault = 0
      },


      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         var oldData = this.actionData.oldData
         this.filterMainField()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         } else {
            this.tables = true
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 3) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getBtnHeight()
               }
               this.initFocus();
            }, 16.7)
         });
      },
      sendDataAction(sendDataInfo) {
         if (this.sendDataInfo.prrmitDate && this.sendDataInfo.prrmitDate < new Date().getTime()) {
            return this.$message.error('许可证有效期不得早于当前时间')
         }
         if (this.sendDataInfo.licenseDate && this.sendDataInfo.licenseDate < new Date().getTime()) {
            return this.$message.error('营业执照有效期不得早于当前时间')
         }
         if (this.sendDataInfo.contractDate && this.sendDataInfo.contractDate < new Date().getTime()) {
            return this.$message.error('合同有效期不得早于当前时间')
         }
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         if (this.sendDataInfo.dewmuLogisticsCars.length == 0) {
            return this.$message.error("请维护车辆")
         }
         var carFlag = false
         this.sendDataInfo.dewmuLogisticsCars.forEach(item => {
            if ((item.filingCard == "" || item.travelLicense == "" || item.travelLicenseDate == "") && !carFlag) {
               carFlag = true
            }
         })
         if (carFlag) {
            return this.$message.error("请先完善车辆未完善的信息,再保存")
         }
         if (this.sendDataInfo.dewmuLogisticsDrivers.length == 0) {
            return this.$message.error("请维护司机")
         }
         var driverFlag = false
         this.sendDataInfo.dewmuLogisticsCars.forEach(item => {
            if ((item.driverName == "" || item.documentsNum == "" || item.drivingLicenseDate == "") && !driverFlag) {
               driverFlag = true
            }
         })
         if (driverFlag) {
            return this.$message.error("请先完善司机未完善的信息,再保存")
         }
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            // 新增物流信息
            var responseData = await this.$http.addLogistics(sendData);
         } else {
            // 修改物流信息
            var responseData = await this.$http.updateLogistics(sendData);
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit('drawerCancel', true)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = [{ entityField: "dewmuLogisticsDrivers" }, { entityField: "dewmuLogisticsCars" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         var obj1 = this.$common.filterMainFields([], [], mainFormList[1])
         var obj2 = this.$common.filterMainFields([], [], mainFormList[2])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         for (let key in obj1) {
            this.$set(this.carObj, key, obj1[key])
         }
         for (let key in obj2) {
            this.$set(this.driverObj, key, obj2[key])
         }
         this.$set(this.sendDataInfo, "isDefault", 0)
         this.showTabs = this.tabForm[0].jciName
      },
      imgur() {
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgur()
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.mb {
   margin-bottom: 0;
}

.newInput {
   height: 28px;
   line-height: 28px;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}
#mainInfo ::v-deep .el-form-item__content {
   margin-left: 170px !important;
}
#mainInfo ::v-deep .el-form-item__label {
   width: 170px !important;
}
/* 图片上传样式 */
.uploadList {
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   width: 220px;
   list-style: none;
}

.image {
   position: relative;
   width: 40px;
   height: 40px;
   margin-right: 5px;
   margin-bottom: 5px;
   flex-shrink: 0;
   border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
   margin-right: 0;
}

.del {
   display: none;
   position: absolute;
   top: 0px;
   right: 0px;
   font-size: 14px;
   z-index: 99;
   cursor: pointer;
}

.del:hover {
   color: #409eff;
}

.image:hover .del {
   display: inline-block;
}

.image_label {
   cursor: pointer;
   padding: 7px 10px !important;
   font-size: 12px !important;
   background-color: #409eff;
   color: #ffffff;
   line-height: 14px;
   margin-right: 5px;
   border-radius: 3px;
}

::v-deep .el-image__error {
   font-size: 7px;
}

/* 明细表单元格图片上传 */
.upload {
   display: flex;
   align-items: center;
   justify-content: center;
   list-style: none;
   padding: 0;
   margin: 0;
}

.upload li {
   position: relative;
   width: 42px;
   height: 42px;
   flex-shrink: 0;
}

.upload li:hover .del {
   display: inline-block;
}

.upload .image_label {
   display: flex;
   align-items: center;
   justify-content: center;
   width: 42px;
   height: 42px;
   padding: 0 !important;
   margin-right: 0;
   background-color: transparent;
   border: 1px dashed #838383;
   border-radius: 3px;
   box-sizing: border-box;
}

.upload .image_label:hover {
   border: 1px dashed #409eff;
   cursor: pointer;
}

.upload .image_label:hover .icon {
   color: #409eff;
}

.upload li .icon {
   color: #838383;
   font-size: 20px;
   line-height: 1;
}

/* 明细表文件上传 */
.file-item {
   position: relative;
   display: flex;
   align-items: center;
   justify-content: center;
   width: 100%;
   min-height: 42px;
   padding: 2px 4px;
   box-sizing: border-box;
}

.file-item:hover .del {
   display: inline-block;
}

.file-item .del {
   position: absolute;
   top: -6px;
   right: -6px;
   z-index: 10;
   font-size: 16px;
   color: #F56C6C;
   cursor: pointer;
   display: none;
}

.file-link {
   display: flex;
   align-items: center;
   max-width: 100%;
   color: #409eff;
   text-decoration: none;
   cursor: pointer;
}

.file-link:hover {
   text-decoration: underline;
}

.file-link .el-icon-document {
   font-size: 16px;
   margin-right: 4px;
   flex-shrink: 0;
}

.file-name {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   font-size: 12px;
}

.file-item .image_label {
   display: flex;
   align-items: center;
   justify-content: center;
   width: 42px;
   height: 42px;
   margin: 0 auto;
   padding: 0 !important;
   background-color: transparent;
   border: 1px dashed #838383;
   border-radius: 3px;
   box-sizing: border-box;
}

.file-item .image_label:hover {
   border: 1px dashed #409eff;
   cursor: pointer;
}

.file-item .image_label:hover .icon {
   color: #409eff;
}

.file-item .image_label .icon {
   color: #838383;
   font-size: 20px;
   line-height: 1;
}
</style>